export const characters = {
  title: "Personagens",
  subtitle: "Crie e gerencie personagens para automatizar suas tarefas",
  newCharacter: "Novo Personagem",
  noCharacters: "Nenhum personagem encontrado",
  edit: "Editar",
  delete: "Excluir",
  name: "Nome",
  description: "Descrição",
  systemPrompt: "Prompt do Sistema",
  temperature: "Temperatura",
  model: "Modelo",
  tools: "Ferramentas",
  create: "Criar Personagem",
  table: {
    title: "Nome",
    description: "Descrição",
    tools: "Ferramentas",
    actions: "Ações",
    public: "Público",
    private: "Privado",
  },
  actions: {
    edit: "Editar",
    delete: "Excluir",
    chat: "Chat com o personagem",
  },
  profilePicture: "Foto de Perfil (URL)",
  tagline: "Tagline",
  greeting: "Mensagem de Boas-Vindas",
  public: "Público",
  update: "Atualizar",
};
